export enum CreditCardType {
    Visa = 'Visa',
    Mastercard = 'MasterCard',
    Discover = 'Discover',
    Amex = 'Amex',
}